import { render, staticRenderFns } from "./ticket-card.vue?vue&type=template&id=46312694&scoped=true"
import script from "./ticket-card.vue?vue&type=script&lang=js"
export * from "./ticket-card.vue?vue&type=script&lang=js"
import style0 from "./ticket-card.vue?vue&type=style&index=0&id=46312694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46312694",
  null
  
)

export default component.exports